import { type Emoji, EmojiPicker as SolidEmojiPicker } from "solid-emoji-picker"
import { Suspense } from "solid-js"
import { emojiPickerClass } from "./emoji-picker.css"

interface EmojiPickerProps {
  onEmojiClick: (emoji: Emoji) => void
  filter?: (emoji: Emoji) => boolean
}

export function EmojiPicker(props: EmojiPickerProps) {
  return (
    <Suspense fallback={<div>Loading emojis...</div>}>
      <div class={emojiPickerClass}>
        <SolidEmojiPicker
          onEmojiClick={props.onEmojiClick}
          filter={props.filter}
          renderEmoji={(_emojis, emoji) => (
            <span class="emoji">{emoji.emoji}</span>
          )}
        />
      </div>
    </Suspense>
  )
}
